import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { AppState } from '../../../core/redux/appState';
import { Action } from 'redux';

type SetDevPlanViewedAction = {
  type: ActionType.SetDevPlanViewedAction;
  viewed: boolean;
};

export const setDevPlanViewedAction = (
  viewed: boolean,
): SetDevPlanViewedAction => ({
  type:   ActionType.SetDevPlanViewedAction,
  viewed: viewed,
});

export const setDevPlanViewedReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.SetDevPlanViewedAction) {
    return state;
  }

  const sdpva = action as SetDevPlanViewedAction;

  return R.assocPath(['devPlan', 'viewed'], sdpva.viewed, state);
};
